(() => {
  // Highlights do not have destination/provider rate data. Do not synthesize
  // an arrival window or a shipping origin from the browser date.
  const syncHighlights = () => {
    document.querySelectorAll(".etsy-item-details__highlights").forEach((highlights) => {
      highlights.querySelectorAll(".etsy-item-highlight--delivery").forEach((row) => row.remove());
      highlights.querySelectorAll(".etsy-item-highlight--ships-from").forEach((row) => {
        // A supplier-verified server-rendered origin can be retained. There is
        // deliberately no default country and no inferred provider location.
        if (row.dataset.originVerified !== "true" || !row.dataset.originSource?.trim()) {
          row.remove();
        }
      });
    });
  };

  syncHighlights();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncHighlights, { once: true });
  }
  document.addEventListener("shopify:section:load", syncHighlights);
})();
